import { defineMessages } from 'react-intl';

export const estimationItemDetailModalMessageDefinitions = defineMessages({
  title: {
    id: 'estimationDetail.estimationItemDetailModal.title',
    defaultMessage: 'Edit Estimation Phase',
  },
  assumptionsButton: {
    id: 'estimationDetail.estimationItemDetailModal.assumptionsButton',
    defaultMessage: 'Assumptions',
  },
  commentsButton: {
    id: 'estimationDetail.estimationItemDetailModal.commentsButton',
    defaultMessage: 'Comments',
  },
  removePhaseButton: {
    id: 'estimationDetail.estimationItemDetailModal.removePhaseButton',
    defaultMessage: 'Remove Phase',
  },
  overrideOriginalEstimateButton: {
    id: 'estimationDetail.estimationItemDetailModal.overrideOriginalEstimateButton',
    defaultMessage: 'Update Original Estimate',
  },
  subItemsTitle: {
    id: 'estimationDetail.estimationItemDetailModal.subItemsTitle',
    defaultMessage: 'Subitems in Phase',
  },
  unsavedChangesTitle: {
    id: 'estimationDetail.estimationItemDetailModal.unsavedChangesTitle',
    defaultMessage: 'Unsaved Changes',
  },
  unsavedChangesWarning: {
    id: 'estimationDetail.estimationItemDetailModal.unsavedChangesWarning',
    defaultMessage:
      'You have unsaved changes to this estimation phase. How would you like to proceed?',
  },
  discardAndCloseButton: {
    id: 'estimationDetail.estimationItemDetailModal.discardAndCloseButton',
    defaultMessage: 'Discard and close',
  },
});
